import {SigninService} from './auth/signin/signin.service';
import {DossierService} from './dossier/dossier.service';
import {APP_BASE_HREF} from '@angular/common';
import {AuthGuard} from './guard/auth.guard';
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {JWTInterceptor} from './auth/auth-http-client/auth-http-client.module';
import {VisioGuard} from './guard/visio.guard';
import {AutologService} from './autolog/autolog.service';
import {DetectBrowserService} from './detect-browser.service';
import {PhotoService} from './photo/photo.service';

export const PROVIDERS = [
  AuthGuard,
  VisioGuard,
  SigninService,
  DossierService,
  AutologService,
  DetectBrowserService,
  PhotoService,
  {
    provide: APP_BASE_HREF,
    useValue: '/'
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: JWTInterceptor,
    multi: true,
  }
];




// WEBPACK FOOTER //
// ./src/app/app.module.providers.ts